import { useMutation, useQuery, useQueryClient } from 'react-query'
import { AxiosError } from 'axios'
import { getAdminMerchantStatus, resetPaymentsApplication } from './paymentsResetApi'

export const useAdminMerchantStatusQuery = (tenantId: number | undefined) => {
  return useQuery(['admin', 'rainforest', 'merchant-status', tenantId ?? 0], {
    queryFn: () => getAdminMerchantStatus(tenantId as number),
    enabled: tenantId !== undefined,
    refetchOnWindowFocus: false,
  })
}

export const useResetPaymentsApplicationMutation = () => {
  const queryClient = useQueryClient()
  return useMutation<void, AxiosError, number>({
    mutationFn: (tenantId: number) => resetPaymentsApplication(tenantId),
    onSuccess: (_, tenantId) => {
      queryClient.invalidateQueries(['admin', 'rainforest', 'merchant-status', tenantId])
    },
  })
}
